/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAllExamLookups: {
        $xmlns: 'http://dobs.pa.gov/nd/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllExamLookupsResponse.ExamStatuses.ND_LU_ExamStatus',
      'GetAllExamLookupsResponse.ExamPlacements.ND_LU_ExamPlacement',
      'GetAllExamLookupsResponse.ExamViolationCodes.ND_LU_ExamViolationCode',
      'GetAllExamLookupsResponse.ExamTypes.ND_LU_ExamType',
      'GetAllExamLookupsResponse.ExamViolationCorrectiveActions.ND_LU_ExamViolationCorrectiveAction',
      'GetAllExamLookupsResponse.ComplianceViolations.ND_LU_ComplianceViolation'
    ],
    blueprint: {
      examStatuses: [
        '$..ND_LU_ExamStatus',
        {
          id: '$.ID',
          name: '$.Name'
        }
      ],
      examPlacements: [
        '$..ND_LU_ExamPlacement',
        {
          id: '$.ID',
          name: '$.Name'
        }
      ],
      examViolationCodes: [
        '$..ND_LU_ExamViolationCode',
        {
          id: '$.ID',
          name: '$.Name',
          description: '$.Description'
        }
      ],
      examTypes: [
        '$..ND_LU_ExamType',
        {
          id: '$.ID',
          name: '$.Name'
        }
      ],
      examViolationCorrectiveActions: [
        '$..ND_LU_ExamViolationCorrectiveAction',
        {
          id: '$.ID',
          name: '$.Name',
          description: '$.Description'
        }
      ],
      complianceViolations: [
        '$..ND_LU_ComplianceViolation',
        {
          id: '$.ID',
          name: '$.Name'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
